import React from 'react';
import { IntlProvider } from 'react-intl';

export type AvailableLocale =
  | 'en-US'
  | 'fr-FR'
  | 'es-ES'
  | 'it-IT'
  | 'pl-PL'
  | 'pt-BR'
  | 'ht-HT';

const DEFAULT_LOCALE = 'en-US';
export const locale = (
  typeof window !== 'undefined' ? window.navigator.language : DEFAULT_LOCALE
) as AvailableLocale;

export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

type IntlProviderProps = React.ComponentProps<typeof IntlProvider>;
export const defaultRichTextElements: IntlProviderProps['defaultRichTextElements'] =
  {
    b: chunks => <b>{chunks}</b>,
  };

interface TranslationItem {
  type: number; // Indicates the type of the translation item
  value: string | number; // The actual translation text or placeholder
}
type TranslationMessage = TranslationItem[];
type LocaleTranslations = Record<string, TranslationMessage>;
export type Translations = {
  [locale in AvailableLocale]: LocaleTranslations;
};
